import {
  Flex,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import TableListHelper from "./tableListHelper";
import {
  BLUECARD,
  BLUEMONEDD,
  BLUEMONEDDBUTTONS,
  VARIANT,
} from "../../../../constants/colors";
import { customColors } from "../../../../atoms/customColors";
import { useRecoilState } from "recoil";

export default function CardTableTarifas(props: any) {
  const colors = useRecoilState(customColors)[0];
  return (
    <Flex
      w={"100%"}
      h={"fit-content"}
      bgColor={"white"}
      mx={4}
      borderRadius={"20px"}
      flexDir="column"
      my={3}
    >
      <Flex
        w={"100%"}
        h={"fit-content"}
        bgColor={"#1C3E92"}
        borderRadius={"20px 20px 0px 0px"}
        justifyContent={"start"}
        alignItems={"center"}
      >
        <Text
          fontFamily={"Montserrat"}
          fontWeight={"700"}
          fontSize={"1rem"}
          color={"#FFFFFF"}
          mx={8}
          py={1}
        >
          {props.title ? props.title.toUpperCase() : ""}
        </Text>
      </Flex>
      <TableContainer overflowX="auto">
        <Table>
          <Thead>
            <Tr>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                Bandeiras
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                Débito
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                1X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                2X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                3X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                4X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                5X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                6X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                7X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                8X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                9X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                10X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                11X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                12X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                13X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                14X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                15X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                16X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                17X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                18X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                19X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                20X
              </Th>
              <Th
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                fontSize={"0.7rem"}
              >
                21X
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {props.data.length ? (
              <>
                <TableListHelper
                  text={"MasterCard"}
                  data={props.data}
                  id={2}
                  type={"Credito"}
                />
                <TableListHelper
                  text={"Visa"}
                  data={props.data}
                  id={1}
                  type={"Credito"}
                />
                <TableListHelper
                  text={"American Express"}
                  data={props.data}
                  id={3}
                  type={"Credito"}
                />
                <TableListHelper
                  text={"Aura"}
                  data={props.data}
                  id={11}
                  type={"Credito"}
                />
                <TableListHelper
                  text={"Banescard"}
                  data={props.data}
                  id={10}
                  type={"DebitoCredito"}
                />
                <TableListHelper
                  text={"Diners Club"}
                  data={props.data}
                  id={4}
                  type={"DebitoCredito"}
                />
                <TableListHelper
                  text={"Discover"}
                  data={props.data}
                  id={12}
                  type={"Credito"}
                />
                <TableListHelper
                  text={"Elo"}
                  data={props.data}
                  id={7}
                  type={"DebitoCredito"}
                />
                <TableListHelper
                  text={"Hipercard"}
                  data={props.data}
                  id={8}
                  type={"Credito"}
                />
                <TableListHelper
                  text={"JCB"}
                  data={props.data}
                  id={9}
                  type={"Credito"}
                />
                <TableListHelper
                  text={"Maestro"}
                  data={props.data}
                  id={6}
                  type={"Debito"}
                />
                <TableListHelper
                  text={"Visa Electron"}
                  data={props.data}
                  id={5}
                  type={"Debito"}
                />
              </>
            ) : (
              <Tr w={"100%"} justifyContent={"center"}>
                <Spinner />
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Flex>
  );
}
